import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

const FloatingActionButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);


  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setIsExpanded(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const actions = [
    {
      icon: 'bi-telephone',
      label: 'Call Now',
      action: () => window.location.href = 'tel:+254722655911',
      color: 'bg-green-500 hover:bg-green-600'
    },
    {
      icon: 'bi-envelope',
      label: 'Email Us',
      action: () => window.location.href = 'mailto:kehosainstitute@gmail.com',
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      icon: 'bi-chat-dots',
      label: 'Live Chat',
      action: () => Swal.fire({
        icon: 'info',
        title: 'Coming Soon!',
        text: 'Live chat feature coming soon!',
        confirmButtonColor: '#2563eb'
      }),
      color: 'bg-purple-500 hover:bg-purple-600'
    }
  ];

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Expanded Actions */}
      {isExpanded && (
        <div className="mb-4 space-y-3">
          {actions.map((action, index) => (
            <div
              key={index}
              className={`flex items-center space-x-3 ${action.color} text-white px-4 py-3 rounded-lg shadow-lg transform transition-all duration-300 animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <i className={`${action.icon} text-lg`}></i>
              <span className="font-medium">{action.label}</span>
              <button
                onClick={action.action}
                className="ml-auto bg-white bg-opacity-20 hover:bg-opacity-30 p-2 rounded-full transition-colors duration-200"
              >
                <i className="bi bi-arrow-right text-sm"></i>
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Main FAB */}
      <div className="relative">
        {/* Pulse effect */}
        <div className="absolute inset-0 bg-primary-600 rounded-full animate-ping opacity-20"></div>

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="relative bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white p-4 rounded-full shadow-2xl transform transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-4 focus:ring-primary-300"
        >
          <i className={`bi ${isExpanded ? 'bi-x' : 'bi-three-dots'} text-xl transition-transform duration-300`}></i>
        </button>
      </div>

      {/* Scroll to top button */}
      <button
        onClick={scrollToTop}
        className="block mt-3 bg-white hover:bg-secondary-50 text-primary-600 p-3 rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-4 focus:ring-primary-300"
      >
        <i className="bi bi-chevron-up text-lg"></i>
      </button>
    </div>
  );
};

export default FloatingActionButton;